import { render, staticRenderFns } from "./settingsSubmenu.vue?vue&type=template&id=34766177&"
import script from "./settingsSubmenu.vue?vue&type=script&lang=ts&"
export * from "./settingsSubmenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports